import { WaterOutlineIcon } from './WaterOutlineIcon';

/**
 * author: GreenTurtwig
 * id DC3CFDE4-8FA9-497A-A937-6F7182B560E1
 * name water-outline
 * version: 3.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/water-outline.svg
 * tags
 * - Home Automation 
 * - Weather 
 */
export const WaterDropOutlineIcon = WaterOutlineIcon;
export default WaterDropOutlineIcon